export default __webpack_public_path__ + "static/media/pra.f152a10c.jpeg";